module.exports = __webpack_public_path__ + "media/applicants/ios-298ec158.png";